export const PAYMENT_METHOD_CREDIT_CARD = 'tillPaymentJs';
export const PAYMENT_METHOD_FISERV_IPG = 'fiserv-ipg-card';
export const PAYMENT_METHOD_ALIPAY = 'alipay';
export const PAYMENT_METHOD_PAY_ID = 'zepto payTo';
export const PAYMENT_METHOD_INITIAL = 'initial payment method';
